/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_FebruaryInputs */

const he_month_february = /** @type {(inputs: Month_FebruaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פברואר`)
};

const en_month_february = /** @type {(inputs: Month_FebruaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`February`)
};

/**
* | output |
* | --- |
* | "February" |
*
* @param {Month_FebruaryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_february = /** @type {((inputs?: Month_FebruaryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_FebruaryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_february(inputs)
	return en_month_february(inputs)
});